import React from "react";
import { Image, Row, Col, Card, Nav, Form, Button, Alert, Modal } from "react-bootstrap";
import { FaUser, FaEllipsisV } from "react-icons/fa";
import BrtxSelect from "../../componets/BrtxSelect";
import mobile from "../../componets/json/mobile.json"
import BrtxPhoneInput from "../../componets/BrtxCustom/phone"
import AddAddress from "./componets/AddAdress";
import _renderAddress from "./componets/_renderAddress";

class UserProfile extends React.Component {
    timer = null;
    state = {
        selectGroup: 0,
        anyChange: true,
        user: null,
        address: [],
        addinvoiceaddr: false,
        addaddresstype: ""
    }

    renderUserType(type) {
        switch (type) {
            case "user":
                return "Standartní uživatel";
            case "domain":
                return "Doménový uživatel";
            case "partner":
                return "VIP zákazník";
        }
    }

    renderGroup(group) {
        switch (group) {
            case 0:
                return "Osobní údaje";
            case 1:
                return "Fakturační adresa";
            case 2:
                return "Dodací adresa";
        }
    }

    save = async () => {
        let user = this.state.user;
        user.detail[0].auth = user.detail[0].auth == null ? null : this.props._encrypt(JSON.stringify(user.detail[0].auth));
        this.props.setUser(user);
        const _res = await this.props._api({
            ...this.props,
            method: "post",
            data: this.props._encrypt(JSON.stringify({
                userName: user.userName,
                value: user.detail[0].auth,
                type: "update-personal"
            })),
            endpoint: this.props._endPoints.britex.profile.update,
            param: "",
        });
    }



    handleCHange = (e) => {
        let user = this.state.user;
        if (e.target.id == "val_surname") user.detail[0].auth = {...user.detail[0].auth, surName: e.target.value};
        if (e.target.id == "val_firstname") user.detail[0].auth = {...user.detail[0].auth, firstName: e.target.value};
        if (e.target.id == "val_title") user.detail[0].auth = {...user.detail[0].auth, title: e.target.value};
        if (e.target.id == "val_pre_mobile") user.detail[0].auth = {...user.detail[0].auth, pre_mobile: e.target.value};
        if (e.target.id == "val_mobile") user.detail[0].auth = {...user.detail[0].auth, mobile: e.target.value};
        this.setState({user: user, anyChange: false});
    }

    componentDidMount() {
        this.props.setHeaderPage({
            Icon: <FaUser className="c-placeholder c-green" />,
            Title: "Profil uživatele",
            SubTitle: "",
        });
        let user = this.props.user;
        try {
            if (user.detail[0].auth != null) user.detail[0].auth = JSON.parse(this.props._decrypt(user.detail[0].auth));
        } catch {}
        try {
            if (user.detail[0]._address != null) user.detail[0]._address = JSON.parse(this.props._decrypt(user.detail[0]._address));
        } catch {}
        
       //this.setState({ user: user, address: user.detail[0]._address == null ? [] : user.detail[0]._address })
       this.setState({ user: user, address: [] })
    }

    addressChange = async (e) => {
            let user = this.props.user;
            let newAddress = this.state.address;
            newAddress.push(e);
            user.detail[0]._address = this.props._encrypt(JSON.stringify(newAddress));
            this.props.setUser(user);
            localStorage.setItem("u",this.props._encrypt(JSON.stringify(user)));
            this.setState({address: newAddress});
            const _res = await this.props._api({
            ...this.props,
            method: "post",
            data: this.props._encrypt(JSON.stringify({
                userName: this.props.user.userName,
                value: this.props._encrypt(JSON.stringify(newAddress)),
                type: "update-address"
            })),
            endpoint: this.props._endPoints.britex.profile.update,
            param: "",
        });
    }

    render() {
        return (
            <>
                {this.state.addinvoiceaddr && (
                    <AddAddress {...this.props} change={this.addressChange} open={this.state.addinvoiceaddr} addresstype={this.state.addaddresstype} onHide={() => this.setState({addinvoiceaddr: false})} />
                )}
                <Row>
                    <Col xs={12} className="d-flex justify-content-start align-items-center">
                        <Image src={this.props._defaultImg} roundedCircle width={100} className="me-4 c-profile-avatar cursor-pointer" data-tip="Kliknutím můžete změnit profilovou fotku" />
                        <Row>
                            <Col>
                                <h5><strong>{this.props.user?.userName}</strong></h5><br /><small className="text-muted">{this.renderUserType(this.props.user?.type)}</small>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col xs={12}>
                        <Nav variant="tabs" className="c-tab" defaultActiveKey={this.state.selectGroup}>
                            <Nav.Item>
                                <Nav.Link onClick={() => this.setState({ selectGroup: 0 })} eventKey="0">Osobní údaje</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link onClick={() => this.setState({ selectGroup: 1 })} eventKey="1">Fakturační adresa</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link onClick={() => this.setState({ selectGroup: 2 })} eventKey="2">Dodací adresa</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col xs={12}>
                        {this.state.selectGroup == 0 && (
                            <Alert variant="warning">
                                Vyplněním údajů a odesláním formuláře ke zpracování vyslovujete souhlas s použitím vašich osobních údajů za účelem zpracování vašich požadavků - tento souhlas můžete kdykoliv odvolat pisemnou formou, váš účet bude tímto odvoláním zrušen bez náhrady.
                            </Alert>
                        )}
                        {(this.state.selectGroup == 1) && (
                            <>
                                {this.state.address.filter(e => e.type == "F").length == 0 && (
                                    <Row>
                                        <Col>
                                            <Alert variant="warning">
                                                Pro tento účet neevidujeme žádnou fakturační adresu
                                            </Alert>
                                        </Col>
                                    </Row>
                                )}

                                {this.state.address.filter(e => e.type == "F").length > 0 && (
                                    <>
                                    {this.state.address.filter(e => e.type == "F").map((e,idx) => (
                                        <_renderAddress e={e} idx={idx}/>
                                    ))}
                                    </>
                                )}
                                <Row>
                                    <Col className="d-flex justify-content-center">
                                        <Button variant="success" size="sm" onClick={() => this.setState({addinvoiceaddr: true, addaddresstype: "F"})}>Přidat fakturační adresu</Button>
                                    </Col>
                                </Row>
                            </>
                        )}
                        
                        {(this.state.selectGroup == 2) && (
                            <>
                                {this.state.address.filter(e => e.type == "D").length == 0 && (
                                    <Row>
                                        <Col>
                                            <Alert variant="warning">
                                                Pro tento účet neevidujeme žádnou dodací adresu
                                            </Alert>
                                        </Col>
                                    </Row>
                                )}

                                {this.state.address.filter(e => e.type == "D").length > 0 && (
                                    <>
                                    {this.state.address.filter(e => e.type == "D").map((e,idx) => (
                                        <_renderAddress e={e} idx={idx}/>
                                    ))}
                                    </>
                                )}
                                <Row>
                                    <Col className="d-flex justify-content-center">
                                        <Button variant="success" size="sm" onClick={() => this.setState({ addinvoiceaddr: true , addaddresstype: "D"})}>Přidat dodací adresu</Button>
                                    </Col>
                                </Row>
                            </>
                        )}

                        {this.state.selectGroup == 0 && (
                            <>
                                <Card bg="white">
                                    <Card.Body>
                                        <Row className="mb-4">
                                            <Col>
                                                <h5><strong>{this.renderGroup(this.state.selectGroup)}</strong></h5>
                                            </Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <Col xs={12} md={6}>
                                                <Form.Control type="text" readOnly value={this.state.user?.userName} />
                                                <Form.Text>E-mail</Form.Text>
                                            </Col>
                                            <Col xs={12} md={2}>
                                                <BrtxSelect id="val_pre_mobile" onChange={this.handleCHange} options={mobile} placeholder="+420" /* value={this.state.user?.detail[0].auth?.pre_mobile} */ />
                                                <Form.Text>Předvolba</Form.Text>
                                            </Col>
                                            <Col xs={12} md={4}>
                                                <BrtxPhoneInput id="val_mobile" onChange={(e) => this.handleCHange({...e,target: {...e.target, id: "val_mobile"}})} /* value={this.state.user?.detail[0].auth?.mobile} */ />
                                                <Form.Text>Mobilní telefon</Form.Text>
                                            </Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <Col xs={12} md={2}>
                                                <Form.Control id="val_title" type="text" onChange={this.handleCHange} /* value={this.state.user?.detail[0].auth?.title} */ />
                                                <Form.Text>Titul</Form.Text>
                                            </Col>
                                            <Col xs={12} md={5}>
                                                <Form.Control id="val_firstname" type="text" onChange={this.handleCHange} /* value={this.state.user?.detail[0].auth?.firstName} */ />
                                                <Form.Text>Jméno</Form.Text>
                                            </Col>
                                            <Col xs={12} md={5}>
                                                <Form.Control id="val_surname" type="text" onChange={this.handleCHange} /* value={this.state.user?.detail[0].auth?.surName} */ />
                                                <Form.Text>Příjmení</Form.Text>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} className="d-flex justify-content-end">
                                                <Button variant="success" size="sm" disabled={this.state.anyChange} onClick={this.save}>Aktualizovat</Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </>
                        )}

                    </Col>
                </Row>
            </>
        )
    }
}

export default UserProfile